module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hrms-staappr"
  }, [_c('div', {
    staticClass: "header-paper clearfix"
  }, [_c('div', {
    staticClass: "header-left"
  }, [(_vm.currentDtereqDisp) ? _c('div', {
    staticClass: "box-header-label"
  }, [_c('div', {
    staticClass: "header-label-ico"
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  }), _vm._v(" " + _vm._s(_vm.labels['dtereq'][_vm.nowLang]))]), _vm._v(" "), _c('div', {
    staticClass: "header-label-data"
  }, [_vm._v(": " + _vm._s(_vm.currentDtereq))])]) : _vm._e(), _vm._v(" "), (_vm.currentNumseqDisp) ? _c('div', {
    staticClass: "box-header-label"
  }, [_c('div', {
    staticClass: "header-label-ico"
  }, [_c('i', {
    staticClass: "fa fa-file-text"
  }), _vm._v(" " + _vm._s(_vm.labels['numseq'][_vm.nowLang]))]), _vm._v(" "), _c('div', {
    staticClass: "header-label-data"
  }, [_vm._v(": " + _vm._s(_vm.currentNumseq))])]) : _vm._e(), _vm._v(" "), (_vm.currentCodempidDisp) ? _c('div', {
    staticClass: "box-header-label"
  }, [_c('div', {
    staticClass: "header-label-ico"
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" " + _vm._s(_vm.labels['codempid'][_vm.nowLang]))]), _vm._v(" "), _c('div', {
    staticClass: "header-label-data"
  }, [_vm._v(": " + _vm._s(_vm.currentCodempid))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "header-right"
  }, [_c('div', {
    staticClass: "panel-step-staappr"
  }, [_c('div', {
    staticClass: "staappr-label"
  }, [_vm._v(_vm._s(_vm.labels['status'][_vm.nowLang]))]), _vm._v(" "), _c('div', {
    staticClass: "clearfix mobile-steps-staappr"
  }, [_c('div', {
    staticClass: "step",
    class: _vm.class_active_new
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "step-name"
  }, [_vm._v("\n              " + _vm._s(_vm.labels['new'][_vm.nowLang]) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "step",
    class: _vm.class_active_p
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "step-name"
  }, [(_vm.status == 'C') ? [_vm._v("\n                " + _vm._s(_vm.labels['c'][_vm.nowLang]) + "\n              ")] : [_vm._v("\n                " + _vm._s(_vm.labels['p'][_vm.nowLang]) + "\n              ")]], 2)]), _vm._v(" "), _c('div', {
    staticClass: "step",
    class: _vm.class_active_a
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "step-name"
  }, [_vm._v("\n            " + _vm._s(_vm.labels['a'][_vm.nowLang]) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "step",
    class: _vm.class_active_y
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "step-name"
  }, [(_vm.status == 'N') ? [_vm._v("\n                " + _vm._s(_vm.labels['n'][_vm.nowLang]) + "\n              ")] : [_vm._v("\n                " + _vm._s(_vm.labels['y'][_vm.nowLang]) + "\n              ")]], 2)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticClass: "circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticClass: "line"
  }), _vm._v(" "), _c('span', {
    staticClass: "circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticClass: "line"
  }), _vm._v(" "), _c('span', {
    staticClass: "circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticClass: "line"
  }), _vm._v(" "), _c('span', {
    staticClass: "circle"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-54611288!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hrmsStaappr/component.vue
// module id = 3764
// module chunks = 1